import { render, staticRenderFns } from "./LhcInfo.vue?vue&type=template&id=dc645c24&"
import script from "./LhcInfo.vue?vue&type=script&lang=js&"
export * from "./LhcInfo.vue?vue&type=script&lang=js&"
import style0 from "./LhcInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports